module.exports = __webpack_public_path__ + "static/media/me.8af86be7.jpeg";